<div class="edit-user-container flex space-between">
  <h2 class="grey-font" style="margin:0; padding-left:17px;">
    User Rights
  </h2>
  <mat-slide-toggle #adminToggle [(ngModel)]="SelectedUser.isAdmin" (change)="setAdmin($event)" [disabled]="loadingOrUserNotSelected" style="padding-right: 5px;">Administrator</mat-slide-toggle>
  <span *ngIf="!isEOR">
    <mat-slide-toggle #claimantToggle [(ngModel)]="SelectedUser.isClaimantUser" (change)="setClaimant($event)" [disabled]="loadingOrUserNotSelected" style="padding-right: 5px;">Claimant</mat-slide-toggle>
  </span>
</div>
